module.exports = __webpack_public_path__ + "static/media/hamburger.f93fa330.png";